export default __webpack_public_path__ + "static/media/SD-gallery-02.1bf90b63.png";